import { Segment } from '~src/interfaces/segment.interface';
import { ContentLocalesI } from './session.types';

export enum AttrInternalType {
  Manager = 'manager',
  Setting = 'setting',
  Option = 'option',
  Decimal = 'decimal',
  Datetime = 'datetime',
}

export enum AttrSlugType {
  AnonymityMinAnswers = 'lls_system_anonymity_min_answers',
  SystemLanguage = 'lls_system_language',
  ContentLanguage = 'lls_content_language',
  Manager = 'lls_manager',
  Timezone = 'lls_timezone',
  AIRecommendations = 'lls_system_chatgpt_recommendations_enabled',
  SpidergraphByRespondents = 'lls_system_spidergraph_group_by_respondents_enabled',
  SelfSignUp = 'lls_system_user_self_signup_enabled',
  AdminsCanViewManagerSurveys = 'lls_admins_can_view_manager_surveys',
}

export interface AttributeOptionI {
  uuid: string;
  value: ContentLocalesI;
  position: number;
  segments?: Segment[];
  framework?: boolean;
}

export interface AttributeI extends AttributePatch {
  attribute_options: AttributeOptionI[];
  created_at: string;
  internal_type: AttrInternalType;
  slug: string;
  updated_at: string;
  uuid: string;
}

export interface AttributePatch {
  description: ContentLocalesI;
  hide_from_users: boolean;
  name: ContentLocalesI;
  self_assignable: boolean;
}
